'use strict';

var base = require('client_core/contact/contact');
var formErrors = require('base/checkout/formErrors');
var recaptcha = require('core/components/recaptcha');

base.contactFormHandler = function () {
    $('#contact-form').on('submit', function (e) {
        e.preventDefault();

        var $form = $(this);
        var data = $form.serialize();

        $form.spinner().start();

        recaptcha.check(e, {
            url: $form.attr('action'),
            method: $form.attr('method'),
            data: data,
            success: function (result) {
                $form.spinner().stop();

                if (!result.success) {
                    formErrors.loadFormErrors($form, result.errorMessages);
                    return;
                }

                var $contactSuccess = $('#contact-success');
                $contactSuccess.removeClass('d-none');
                $('.contact-form-component').addClass('d-none');
            },
            error: function (err) {
                $form.spinner().stop();
                if (err && err.responseJSON && err.responseJSON.redirectUri) {
                    window.location.href = err.responseJSON.redirectUrl;
                }
            }
        });
    });

    $('#contact-success .btn').on('click', function () {
        var $contactForm = $('#contact-form');
        $contactForm.find('input, textarea').each(function () {
            if ($(this).data('do-not-clear')) {
                return;
            }
            $(this).val('');
        });
        $contactForm.find('select').each(function ( ) {
            $(this).find('option').first().prop('selected', true);
            $(this).trigger('change');
        });

        $('#contact-success').addClass('d-none');
        $('#contact-success').find('.alert').remove();
        $contactForm.removeClass('d-none');
    });

};

module.exports = base;
